import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { passkeySupported, passkeyRegister } from "@/lib/passkey";
import { fmtDate } from "@/components/DatePicker";
import { Fingerprint, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

export function PasskeySettings() {
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(false);
  const supported = passkeySupported();
  const load = () => api.get("/auth/passkey").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => {
    setBusy(true);
    try { await passkeyRegister(/iPhone|iPad/.test(navigator.userAgent) ? "iPhone / iPad" : /Android/.test(navigator.userAgent) ? "Android phone" : "This device"); toast.success("Face ID / fingerprint sign-in enabled on this device"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || (e.name === "NotAllowedError" ? "Biometric prompt was cancelled or not available here" : e.message || "Could not add passkey")); }
    finally { setBusy(false); }
  };
  const del = async (p) => { if (!window.confirm(`Remove "${p.label}"? You'll sign in with your password on that device.`)) return; await api.delete(`/auth/passkey/${p.id}`); load(); };
  return (
    <div className="rounded-lg border p-3 space-y-2" data-testid="passkey-settings">
      <div className="flex items-center justify-between gap-3">
        <div><Label className="flex items-center gap-1.5"><Fingerprint className="w-4 h-4" /> Face ID / fingerprint sign-in</Label>
          <p className="text-xs text-muted-foreground">{supported ? "Unlock RightPay with your device biometrics instead of a password (passkey)." : "Passkeys aren't supported in this browser."}</p></div>
        <Button size="sm" variant="outline" data-testid="passkey-add" disabled={!supported || busy} onClick={add}><Plus className="w-3.5 h-3.5 mr-1" /> Add this device</Button>
      </div>
      {list.length > 0 && <div className="divide-y text-sm">
        {list.map((p) => <div key={p.id} className="flex items-center justify-between py-1.5" data-testid={`passkey-row-${p.id}`}><span>{p.label} <span className="text-xs text-muted-foreground">· added {fmtDate(p.created_at?.slice(0, 10))}{p.last_used_at ? ` · last used ${fmtDate(p.last_used_at.slice(0, 10))}` : ""}</span></span><button data-testid={`passkey-delete-${p.id}`} onClick={() => del(p)} className="p-1 text-muted-foreground hover:text-rose-600"><Trash2 className="w-3.5 h-3.5" /></button></div>)}
      </div>}
    </div>
  );
}
